import RegistrationTimesDataStore from '../../datastores/RegistrationTimesStore';

interface Schedule {
  day: string;
  start: string;
  end: string;
}

interface RegistrationTime {
  courseId: string;
  section: number;
  schedules: Schedule[];
  teachers: string[];
  typeCourse: string;
}

const registrationTimes: RegistrationTime[] = [
  {
    courseId: '01',
    section: 19426,
    schedules: [
      { day: 'Lunes', start: '08:00', end: '10:00' },
      { day: 'Sábado', start: '08:00', end: '10:00' }
    ],
    teachers: ['Robert Bruce Banner'],
    typeCourse: 'P'
  },
  {
    courseId: '01',
    section: 19566,
    schedules: [
      { day: 'Lunes', start: '14:00', end: '16:00' },
      { day: 'Martes', start: '08:00', end: '10:00' }
    ],
    teachers: ['Scarlett Ingrid Johansson', 'Charles Francis Xavier'],
    typeCourse: 'R'
  },
  {
    courseId: '01',
    section: 19326,
    schedules: [
      { day: 'Lunes', start: '08:00', end: '10:00' },
      { day: 'Sábado', start: '08:00', end: '10:00' }
    ],
    teachers: ['Susana Ivonne Díaz Díaz'],
    typeCourse: 'P'
  },
  {
    courseId: '02',
    section: 19427,
    schedules: [
      { day: 'Martes', start: '08:00', end: '10:00' },
      { day: 'Jueves', start: '08:00', end: '10:00' }
    ],
    teachers: [
      'Rodriguez Zuñiga de Effendi, Grabriela Maria del Rosario',
      'Camila Torres Rodriguez'
    ],
    typeCourse: 'R'
  },
  {
    courseId: '02',
    section: 27427,
    schedules: [
      { day: 'Miércoles', start: '08:00', end: '10:00' },
      { day: 'Viernes', start: '08:00', end: '10:00' }
    ],
    teachers: ['Zully Guevara Castro', 'Camila Torres Rodriguez'],
    typeCourse: 'R'
  },
  {
    courseId: '03',
    section: 19428,
    schedules: [],
    teachers: ['Raúl Gustavo Romero Salazar', 'Carlos Alberto Alcantara Vilar'],
    typeCourse: 'VT'
  },
  {
    courseId: '03',
    section: 34428,
    schedules: [],
    teachers: [
      'Martín Alberto Vizcarra Cornejo',
      'José Pedro Castillo Terrones'
    ],
    typeCourse: 'VT'
  }
];

export default class RegistrationTimesDataStoreMock
  implements RegistrationTimesDataStore
{
  async getRegistrationTimes(courseId: string): Promise<RegistrationTime[]> {
    return registrationTimes.filter(
      (registrationTime) => registrationTime.courseId === courseId
    );
  }
}
